import { Dialog } from 'primereact/dialog';
import { Dispatch, FC, SetStateAction } from 'react';

interface Props {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
}

export const AssignmentReportKeyModal: FC<Props> = ({ visible, setVisible }) => {
  return (
    <Dialog className="w-4" header="Report Key" visible={visible} onHide={() => setVisible(false)}>
      <div className="p-1" style={{ fontFamily: 'Poppins' }}>
        <div className="flex">
          <div className="flex flex-column w-4">
            <span className="nc_keep-learning nc_skill-result-mini text-center">0 - 20%</span>
            <span className="nc_almost-there nc_skill-result-mini text-center my-3">40 - 60%</span>
            <span className="nc_passed nc_skill-result-mini text-center">80 - 100%</span>
          </div>

          <div className="block  w-full flex  align-items-center">
            <div className="ml-4">
              <span>Assessment </span>
              <span className="font-semibold">Score</span>
            </div>
          </div>
        </div>
        <hr />
        <div className="flex mt-3">
          <div className="flex flex-column w-4">
            <span className="nc_passed nc_skill-result-mini text-center">P</span>
          </div>

          <div className="block w-full flex ">
            <div className="ml-4">
              <span>
                <span className="font-semibold">Passed: </span> Skill was demonstrated by passing a skill assessment on
                a related skill.
              </span>
            </div>
          </div>
        </div>
        <div className="flex mt-4">
          <div className="flex flex-column w-4">
            <span className="nc_not-started nc_skill-result-mini text-center font-semibold">Not Started</span>
          </div>

          <div className="block w-full flex ">
            <div className="ml-4">
              <span>
                <span>
                  Skill is assigned but <span className="font-semibold">no skill assessment submitted</span> in the time
                  window.
                </span>
              </span>
            </div>
          </div>
        </div>
        <div className="flex mt-4">
          <div className="flex flex-column w-4">
            <span className="nc_not-started nc_skill-result-mini text-center font-semibold">Not Assigned</span>
          </div>

          <div className="block w-full flex ">
            <div className="ml-4">
              <span>
                <span>
                  <span className="font-semibold">Skill is not assigned</span> to the student because they{' '}
                  <span className="font-semibold">already passed</span> that predecessor.
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
